<template>
  <f7-page no-toolbar   style="padding: 0;">
    <!-- <f7-navbar innerClass="navbar-inner">
      <f7-nav-left>
        <f7-link @click="$f7router.back()">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title></f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar> -->
    <div class="content">
      <div style="padding: 80px 0 20px 0;"><img src="../../../static/images/yt999/home/ico/ZZicon/vip-logo.png"  width="120px"/></div>
      <div class="txt1">{{ $t('invite_friends_before_001') }}</div>
      <div class="txt2">{{ $t('invite_friends_before_002') }}</div>
      <div class="btn" @click="$f7router.navigate('/member-center/invite-friends/')">{{ $t('invite_friends_before_003') }}</div>
    </div>

  </f7-page>
</template>

<script>
import { getCookie } from "@/config/utils";
import { } from "../../../axios/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      
    };
  },
  watch: {},
  computed: {},
  methods: {
    
  },
  created() { 

  },
  mounted() { 
    
  },
};
</script>
<style lang="less" scoped>
  .content{
    background: url(../../../static/images/yt999/invite-friends_bg.png);
    min-height: 100vh;
    background-size: 100% 100%;
    text-align: center;
    color: white;
    .txt1{
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .txt2{
      background: #3c7ec0;
      width: 80%;
      margin: 0 auto;
      margin-bottom: 20px;
      padding: 10px;
      border-radius: 10px;
      // height: 100px;
      text-align: left;

    }
    .btn{
      background: linear-gradient(180deg, #1359BB 9.15%, #58D2FB 90.85%);
      width: 80%;
      margin: 0 auto;
      font-size: 18px;
      color: white;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
    }
  }
  ::v-deep .page-content {
    padding: 0;
  }
  ::v-deep .page-content::after {
    content: "";
    display: block;
    height: 0;
    width: 100%;
}
</style>